import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ProductCategory, ProductCategoryCreate, ProductCategoryFilter } from '../data/productCategory';

export function createProductCategoryService(client: AxiosInstance) {
  return createCrudService<ProductCategory, ProductCategoryCreate, ProductCategoryFilter>(
    client,
    '/master-data/ProductCategory',
    'id',
  );
}

export type ProductCategoryService = CrudService<ProductCategory, ProductCategoryCreate, ProductCategoryFilter>;
